import { api } from '@/core/lib/apiClient';
import type { Ring, StudioResource } from './contracts';
export type StudioKind = 'perspective-splits' | 'post-collaborations';
const path = (kind: StudioKind, slug?: string) =>
  `/${kind}/${slug ? encodeURIComponent(slug) + '/' : ''}`;
export const studio = {
  list: (kind: StudioKind, cursor?: string) =>
    api<{ items: StudioResource[]; next?: string }>(
      path(kind) + (cursor ? `?cursor=${encodeURIComponent(cursor)}` : ''),
    ),
  get: (kind: StudioKind, slug: string) => api<StudioResource>(path(kind, slug)),
  save: (kind: StudioKind, title: string, data: unknown, resource?: StudioResource) =>
    api<StudioResource>(path(kind, resource?.slug), {
      method: resource ? 'PATCH' : 'POST',
      body: {
        title,
        description: '',
        visibility: 'private',
        data,
        ...(resource ? { revision: resource.revision } : {}),
      },
    }),
  action: (
    kind: StudioKind,
    resource: StudioResource,
    action: string,
    values: Record<string, unknown> = {},
  ) =>
    api<StudioResource>(path(kind, resource.slug) + 'actions/', {
      method: 'POST',
      body: { action, revision: resource.revision, ...values },
    }),
  remove: (kind: StudioKind, resource: StudioResource) =>
    api<void>(path(kind, resource.slug), {
      method: 'DELETE',
      body: { revision: resource.revision },
    }),
  rings: () => api<{ items: Ring[] }>('/audience-rings/'),
  saveRing: (name: string, people: string[], ring?: Ring) =>
    api<Ring>(`/audience-rings/${ring ? encodeURIComponent(ring.id) + '/' : ''}`, {
      method: ring ? 'PATCH' : 'POST',
      body: { name, people, ...(ring ? { revision: ring.revision } : {}) },
    }),
  deleteRing: (ring: Ring) =>
    api<void>(`/audience-rings/${encodeURIComponent(ring.id)}/`, {
      method: 'DELETE',
      body: { revision: ring.revision },
    }),
};
